// extracted by mini-css-extract-plugin
export default {"overlay":"PopupInfo_overlay__W8g8f","wrapper":"PopupInfo_wrapper__tUTBh","backgroung":"PopupInfo_backgroung__ONhC8","info":"PopupInfo_info__eoDu5"};